type EmptyStateProps = {
  onReset: () => void;
  title?: string;
  description?: string;
};

const EmptyState = ({
  onReset,
  title = "暂无符合条件的影视作品",
  description = "换个筛选组合试试，或者重置条件查看全部资料。",
}: EmptyStateProps) => (
  <div className="rounded-lg border border-dashed border-background-300 bg-background-100/50 px-6 py-16 text-center">
    <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-500">
      <i className="ri-film-line text-xl" />
    </span>
    <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
    <p className="mt-2 text-sm text-foreground-500">{description}</p>
    <button
      type="button"
      onClick={onReset}
      className="mt-5 inline-flex cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <i className="ri-refresh-line" />
      </span>
      重置筛选条件
    </button>
  </div>
);

export default EmptyState;